<script setup lang="ts">
const props = defineProps({
  selectedTokens: {
    type: Array as PropType<ParagraphTokens>,
    required: true,
  },
});

const documentId = inject("documentId") as any;

onMounted(() => {
  const positions = props.selectedTokens.map((token) => {
    const id = token.id;
    const position =
      useDocumentTokenIdPositionMapStore(documentId).tokenGlobalPositionFromId(
        id
      );

    return position;
  });

  useDocumentHighlightStore(documentId).setTokenPositionsToHighlight(positions);
});
</script>

<template>
  <div>
    <DocumentParagraphsToken
      v-for="token in selectedTokens"
      :base-token="token"
      :paragraph-formatting="{} as any"
      :is-assignment-token="false"
    />
  </div>
</template>

<style scoped></style>
